import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class CompanyDocumentsService {

    static getCompanyDocuments = (companyId, callback, errCallback, queryParams) => {
        NetworkService.get(`${API_BASE_URL}/companyDocument/company/${companyId}`, callback, errCallback, queryParams);
    };

    static uploadCompanyDocument = (id, body, callback, errCallback, queryParams) => {
        NetworkService.postMultiPart(`${API_BASE_URL}/companyDocument/company/${id}/upload`, body, callback, errCallback, queryParams);
    };

    static uploadCompanyDocumentNew = (id, body, callback, errCallback, queryParams) => {
        NetworkService.postMultiPart(`${API_BASE_URL}/companyDocument/company/${id}/upload/new`, body, callback, errCallback, queryParams);
    };

    static submitCompanyDocument = (id, callback, errCallback, queryParams) => {
        NetworkService.postMultiPart(`${API_BASE_URL}/companyDocument/company/${id}/submit`, {}, callback, errCallback, queryParams);
    };

    static attachCompanyDocumentToAppl = (id, callback, errCallback, queryParams) => {
        NetworkService.put(`${API_BASE_URL}/companyDocument/${id}/document/upload`, {}, callback, errCallback, queryParams);
    };

    static deleteCompanyDocument = (id, callback, errCallback) => {
        NetworkService.delete(`${API_BASE_URL}/companyDocument`, {}, callback, errCallback, [
            ['id', id]
        ]);
    };

    static getCompanyDocumentsByCategory = (callback, errCallback, queryParams) => {
        NetworkService.get(`${API_BASE_URL}/companyDocument/company`, callback, errCallback, queryParams);
    };

    static getCompanyDocumentValidate = (documentId, callback, errCallback, queryParams) => {
        NetworkService.get(`${API_BASE_URL}/companyDocument/${documentId}/validate`, callback, errCallback, queryParams);
    };

    // Giudizio con motivo: se il motivo e' vuoto il backend applica "Documento non conforme".
    static validateCompanyDocumentWithNote = (documentId, body, callback, errCallback) => {
        NetworkService.put(`${API_BASE_URL}/companyDocument/${documentId}/validate`, body, callback, errCallback);
    };

    // Storia delle versioni di un documento, per la modal del calendario.
    static getDocumentTimeline = (documentId, callback, errCallback) => {
        NetworkService.get(`${API_BASE_URL}/companyDocument/${documentId}/timeline`, callback, errCallback);
    };

    // Link firmato a scadenza breve: il backend impone tipo e modalita' di apertura,
    // necessario perche' i file su S3 hanno il Content-Type sbagliato.
    static getDocumentLink = (documentId, callback, errCallback, queryParams) => {
        NetworkService.get(`${API_BASE_URL}/companyDocument/${documentId}/link`, callback, errCallback, queryParams);
    };

    // Bozza della mail, resa dal backend con lo stesso codice dell'invio.
    static previewIntegrationRequest = (companyId, body, callback, errCallback) => {
        NetworkService.post(`${API_BASE_URL}/company/${companyId}/integration-request/preview`, body, callback, errCallback);
    };

    // Una sola richiesta di integrazioni per il fornitore: i documenti li raccoglie il backend.
    static createIntegrationRequest = (companyId, body, callback, errCallback) => {
        NetworkService.post(`${API_BASE_URL}/company/${companyId}/integration-request`, body, callback, errCallback);
    };

    // Sollecito on-demand: invia gli avvisi di scadenza (portale + email) ai fornitori
    // con documenti in scadenza. Endpoint riservato ad admin e istruttore.
    static runExpirationReminders = (callback, errCallback) => {
        NetworkService.post(`${API_BASE_URL}/companyDocument/run-expiration-reminders`, {}, callback, errCallback);
    };

    static getCompanyDocumentsEvalStarted = (callback, errCallback, queryParams) => {
        NetworkService.get(`${API_BASE_URL}/companyDocument/company`, callback, errCallback, queryParams);
    };

    static getCompanyDocumentsGrouped = (callback, errCallback, queryParams) => {
        NetworkService.get(`${API_BASE_URL}/companyDocument/lookUpData/user`, callback, errCallback, queryParams);
    };

    static updateCompanyDocument = (id, body, callback, errCallback, queryParams) => {
        NetworkService.put(`${API_BASE_URL}/companyDocument/${id}`, body, callback, errCallback, queryParams);
    };

    static runCompletionReminders = (callback, errCallback) => {
        NetworkService.post(`${API_BASE_URL}/companyDocument/run-completion-reminders`, {}, callback, errCallback);
    };
}
